const Cookies = () => {
  return (
    <>
      <main className="container max-w-5xl mx-auto">
        <div className="text-lg font-semibold text-gray-600 py-8 px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl drop-shadow-xl text-teal-500 font-bold mb-2">
              OUR USE OF COOKIES
            </h2>
            <hr className="border-teal-400 border-[1.5px] dark:border-gray-700 mb-1.5"></hr>

            <hr className="border-teal-400 border-[1.5px] dark:border-gray-700 "></hr>
            <p className="mt-4">
              We are MK CONSULTANCY(UK) LTD, a company incorporated in the UK
              under company number 10180820, having the registered address at
              244 Chase Road, London, United Kingdom, N14 6HH.
            </p>
            <p className="mt-8  ">
              Our website uses cookies to distinguish you from other Users of
              our Website. This helps us to provide you with a good experience
              when you browse our website and also allows us to improve our
              Site.
            </p>
            <p className="mt-8">
              This cookie policy (together with our privacy policy) sets out the
              basis on which any personal information that we collect from you,
              or that you provide to us, when using this site will be processed.
              Please read the following carefully to understand how we use
              cookies.
            </p>
            {/* link's */}
            <div className="mt-8">
              <h3 className="text-xl font-bold text-teal-500">
                WHAT ARE COOKIES?
              </h3>
              <p className="mt-2 text-gray-600">
                Cookies are small text files that are designed to store
                information on your computer. A cookie file is created when you
                use our website and is processed by the software of your
                computer. The resulting text file is placed on your computer and
                it is accessed by your web browser when you visit the website
                that originally created the cookie. For your reference, we set
                out below the wording we use in our cookie banner:
              </p>
              <p className="mt-8 text-gray-600 italic">
                "We collect cookies to enable the proper functioning and
                security of our website, and to enhance your experience. By
                clicking on 'Accept All Cookies', you consent to the use of
                these cookies. You can change your 'Cookies Settings' at
                anytime. For more information, please read our{" "}
                <a
                  href="https://cloudifiers.co.uk/ "
                  className="text-teal-500 underline"
                >
                  Cookie Notice."
                </a>
              </p>
              <p className="mt-8 text-gray-600 italic">
                You can find more information about cookies at:{" "}
                <a
                  href="https://www.allaboutcookies.org"
                  className="text-teal-500 underline"
                >
                  www.allaboutcookies.org
                </a>{" "}
                and{" "}
                <a
                  href="https://www.youronlinechoices.eu"
                  className="text-teal-500 underline"
                >
                  www.youronlinechoices.eu.
                </a>
              </p>
            </div>

            <div className="mt-8">
              <h3 className="text-xl font-bold text-teal-500">
                TYPES OF COOKIES
              </h3>
              <p className="mt-2 text-gray-600 ">
                The cookies described below are used to improve our website and
                do not contain any personal information that would allow us to
                identify you (such as your name or other contact details). The
                types of cookies that may be used during your visit to our
                website are:
              </p>
              <ul className="mt-4 text-gray-600 font-semibold list-disc list-inside mb-6">
                <div className="flex mx-2">
                  <li className=" "></li>
                  <p>
                    Strictly Necessary Cookies: These cookies are necessary for
                    the website to function and cannot be switched off in our
                    systems. They are usually only set in response to actions
                    made by you which amount to a request for services, such as
                    setting your privacy preferences, logging in or filling in
                    forms. You can set your browser to block or alert you about
                    these cookies, but some parts of the site will not then
                    work. These cookies do not store any personally identifiable
                    information.
                  </p>
                </div>

                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p className="">
                    Performance Cookies: These cookies allow us to count visits
                    and traffic sources so we can measure and improve the
                    performance of our site. They help us to know which pages
                    are the most and least popular and see how visitors move
                    around the site. All information these cookies collect is
                    aggregated and therefore anonymous. If you do not allow
                    these cookies we will not know when you have visited our
                    site, and will not be able to monitor its performance.
                  </p>
                </div>
                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p>
                    Targeting Cookies: These cookies may be set through our site
                    by our advertising partners. They may be used by those
                    companies to build a profile of your interests and show you
                    relevant adverts on other sites. They do not store directly
                    personal information, but are based on uniquely identifying
                    your browser and internet device. If you do not allow these
                    cookies, you will experience less targeted advertising.
                  </p>
                </div>
              </ul>
            </div>
            <div className="mt-8">
              <h3 className="text-xl font-bold text-teal-500">
                HOW LONG WILL COOKIES STAY ON MY BROWSING DEVICE?
              </h3>
              <p className="mt-2 text-gray-600">
                The length of time a cookie will stay on your browsing device
                depends on whether it is a “persistent” or “session” cookie.
                Session cookies will only stay on your device until you stop
                browsing. Persistent cookies stay on your browsing device until
                they expire or are deleted.
              </p>

              <h3 className="mt-8 text-xl font-bold text-teal-500">
                HOW TO CONTROL AND DELETE COOKIES THROUGH YOUR BROWSER
              </h3>
              <p className="mt-2 text-gray-600">
                The browser you are using to view the Site can enable, disable
                or delete cookies. To do this, follow the instructions provided
                by your browser (usually located within the “Help,” “Tools'' or
                “Edit” functions). Please note that if you set your browser to
                disable cookies, you may not be able to access certain parts of
                the Site ( e.g. to apply for a job or post a job. Other parts of
                the Site may also not work properly. You can find out more
                information about how to change your browser cookie settings
                at www.allaboutcookies.org.
              </p>
              <p className="mt-4 text-gray-600">
                Also, you may update your cookie preferences by clicking the
                “Cookie Settings” button at the bottom of the Site’s homepage.
              </p>
              <h3 className="mt-8 text-xl font-bold text-teal-500">
                HOW TO CONTACT US
              </h3>
              <p className="mt-2 text-gray-600">
                If you have any questions about this cookie policy, or how we
                handle your personal information, please contact us.
              </p>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Cookies;
